// lib/whatsapp/lead-ref.ts
/**
 * `lead_ref` — identificador corto por intento de WhatsApp para reconciliar la
 * apertura de `wa.me` (proxy) contra el mensaje realmente recibido por ventas.
 *
 * Plan correccion-data-leads-cpc-vs-campanas 2026-06-25 §"Implementación lead_ref":
 *   - se añade `Ref: PCTG-YYYYMMDD-XXXX` al final del mensaje prellenado;
 *   - el MISMO valor viaja como propiedad en cta_click_whatsapp / wsp_click_*
 *     y en las conversiones Ads secondary;
 *   - NO contiene datos personales.
 *
 * Cuando llega un mensaje real, ventas ve el código y lo cruza contra campaña,
 * keyword, gclid, sesión y CTA. Sin esto, solo hay aproximación por hora.
 */

// Alfabeto sin caracteres ambiguos (0/O, 1/I/L) para que ventas lo transcriba
// sin error desde el chat.
const ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

/** Genera `PCTG-YYYYMMDD-XXXX` con 4 caracteres aleatorios no ambiguos. */
export function generateLeadRef(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  let rand = '';
  for (let i = 0; i < 4; i += 1) {
    rand += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  }
  return `PCTG-${y}${m}${d}-${rand}`;
}

/** Valida el formato canónico de un lead_ref (para tests y guardas). */
export function isValidLeadRef(ref: string): boolean {
  return /^PCTG-\d{8}-[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{4}$/.test(ref);
}

/**
 * Añade el código de referencia al final del mensaje prellenado, en su propia
 * línea, sin tocar el cuerpo (los smoke tests de mensaje siguen matcheando el
 * texto comercial; el `Ref:` solo se agrega al final).
 */
export function appendLeadRef(message: string, leadRef: string): string {
  if (!leadRef) return message;
  return `${message}\n\nRef: ${leadRef}`;
}
